import React from "react";
import { Link, useLocation } from "react-router-dom";
import c2cLogo from "../../assets/images/logo/c2c-logo-black.png";
import { useCourseProgress } from "../../contexts/CourseProgressContext";

const Header = () => {
  const location = useLocation();
  const { getModuleIndex, getProgressPercentage } = useCourseProgress();

  const { current: currentModule, total: totalModules } = getModuleIndex(
    location.pathname
  );
  const progress = getProgressPercentage();

  // Don't show on home page
  if (location.pathname === "/") {
    return null;
  }

  return (
    <header className="bg-white border-b border-gray-200 py-5 shadow-sm mb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src={c2cLogo}
                alt="Carbon to Capital Logo"
                className="h-16 w-auto"
              />
              <div className="ml-3">
                <span className="text-xl font-semibold text-gray-800 block">
                  Carbon Literacy Course
                </span>
                <span className="text-sm text-gray-500">
                  Climate change education for everyone
                </span>
              </div>
            </Link>
          </div>

          {currentModule && (
            <div className="w-1/3">
              <div className="flex flex-col">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-600">
                    Module {currentModule} of {totalModules}
                  </span>
                  <span className="text-sm font-medium text-gray-600">
                    {Math.round(progress)}% Complete
                  </span>
                </div>
                <div className="bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-edu-orange h-3 rounded-full"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
